var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"left-container"},[_c('categroy-list',{on:{"selected":_vm.selected}})],1),_c('div',{staticClass:"right-container"},[_c('navigation-list',{attrs:{"category-id":_vm.categoryId}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }